export const MAP_EMBEDDING_CONFIGS_QUERY_KEY = 'map-embedding-configs';
